import React, { useEffect, useState } from "react";
import UserModel from "./models/UserModel";
import axios from "axios";
import DDOption, { GroupedOption } from "../../shared/models/DropdownModels";
import Select from 'react-select'
import { getStorageValues } from "../../shared/CommonFunctions";
import { getApiBaseUrl } from '../../utils/apiConfig';
function AddUser({ sendDataToParent, onLoad }) {
  const [getUser, setUserList] = useState(new UserModel() || []);
  const [companyOptions, setCompanyOptions] = useState(new GroupedOption() || []);
  const [roleOptions, setRoleOptions] = useState(new DDOption() || []);
  const [selectedOption, setSelectedOption] = useState([]);
  const [selectedModuleOption, setSelectedModuleOption] = useState([]);
  const [userModuleOptions, setUserModuleOptions] = useState(new DDOption() || []);
  const [moduleChanged, setModuleChanged] = useState(false);
  const [getPhoneNumber, setPhoneNumber] = useState('');

  const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  };

  const groupBadgeStyles = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    color: '#172B4D',
    display: 'inline-block',
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'center',
  };

  const formatGroupLabel = (data) => (
    <div style={groupStyles}>
      <span>{data.label}</span>
      <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
  );

  function handleChange(e) {
    const { name, value } = e.currentTarget;
    sendDataToParent((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if(name === "PhoneNumber") {
      if (/^\d*$/.test(value)) {
        setPhoneNumber(value);
      }else {
        return;
      }
    }


  }

  function handleRoleChange(e){
    setSelectedOption(e);
    fetchUserModules(e.value);
    if(e !== null){
      sendDataToParent((prevState) => ({
        ...prevState,
        CompanyId: e.groupId,
        RoleId:e.value
      }));
    } else {
      sendDataToParent((prevState) => ({
          ...prevState,
          CompanyId: null,
          RoleId: null
      }));
    }
  };

  function handleUserModuleChange(e){
    setSelectedModuleOption(e);
    setModuleChanged(true);
    if(e !== null){
      sendDataToParent((prevState) => ({
          ...prevState,
          DefaultModuleId: e.value
      }));
    } else {
      sendDataToParent((prevState) => ({
          ...prevState,
          DefaultModuleId: null
      }));
    }
  };
  function setCompanyRolesDropdownData(cr){
    var groupOpt = cr.map(x => ({id: x.CompanyId, label: x.CompanyName, options: null}))
      .filter((value, index, self) => self.findIndex((m) => m.id === value.id) === index);
    let allRoleOpt = [];
    groupOpt.forEach(e => {
      let rlOpt = cr.filter(x => x.CompanyId === e.id);
      let roleOpt = rlOpt.map(p => ({ value:p.RoleId, label: p.RoleName, name: p.RoleName,description:'',isFixed:false,isDisabled:false, groupId: e.id}));
      allRoleOpt.push(roleOpt);
      e.options = roleOpt;
    });
    setRoleOptions(allRoleOpt);
    setCompanyOptions(groupOpt);
  };

  function setUserModuleDropdownData(um){
    let allModuleOpt = [];
    allModuleOpt = um.map( p => ({ value:p.ModuleId, label: p.ParentModuleName + ' -> ' + p.Name, name: p.ParentModuleName + ' -> ' + p.Name,description:'',isFixed:false,isDisabled:false, groupId: null }))
    setUserModuleOptions(allModuleOpt);
  }

  const fetchCompanyRoles = async () => {
    try {
      const response = await axios.get(getApiBaseUrl() + "/getrolesbycompany?CompanyId=" + process.env.REACT_APP_COMPANY_ID);
      if (response.status === 200) {
        setCompanyRolesDropdownData(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchUserModules = async (roleId) => {
    try {
      const response = await axios.get(getApiBaseUrl() + "/usermodulesfdd?UserId=" +
            getStorageValues('userId') + "&RoleId=" + roleId
        );
      if (response.status === 200) {
        setUserModuleDropdownData(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCompanyRoles();
    onLoad(undefined);
  }, []);

  return (
    <div>
      <div className="row">
        <div className="mb-3">
          <label className="form-label">
            Full Name <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="FullName"
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6">
          <div className="mb-3">
            <label className="form-label">
              Email <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="Email"
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="mb-3">
            <label className="form-label">Mobile No </label>
            <input
              type="text"
              className="form-control"
              name="PhoneNumber"
              onChange={handleChange}
              maxLength="10"
              value={getPhoneNumber}
            />
          </div>
        </div>
        <div className="mb-3">
          <label className="form-label">
            UserName <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="UserName"
            autoComplete="off"
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6">
          <div className="mb-3">
            <label className="form-label">
              Password <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="password"
              className="form-control"
              name="Password"
              autoComplete="new-password"
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="mb-3">
            <label className="form-label">
              Confirm Password <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="password"
              className="form-control"
              name="ConfirmPassword"
              autoComplete="new-password"
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="mb-3">
            <label className="form-label">Select Role <span style={{ color: "red" }}>*</span></label>
            <Select
              name="RoleId"
              value={selectedOption ? selectedOption :  []}
              isClearable={true}
              options={companyOptions || []}
              formatGroupLabel={formatGroupLabel}
              onChange={handleRoleChange}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="mb-3">
            <label className="form-label">Select Default Module</label>
            <Select
              name="ModuleId"
              value = {selectedModuleOption ? selectedModuleOption : []}
              isClearable={true} 
              options={userModuleOptions || []}
              onChange={(e) => handleUserModuleChange(e)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddUser;
